import { Event, EventType } from "./Event";

import type { IAddRateEvent } from "./types";

export class AddRateEvent extends Event {
  constructor({
    itemId,
    rating,
    tracking,
    customEventProperties,
  }: IAddRateEvent) {
    super({
      event_type: EventType.rate,
      event_properties: { item_id: itemId, rating, tracking },
      custom_event_properties: customEventProperties,
    });
  }
}
